module.exports = __webpack_public_path__ + "static/media/land-impact.a19612d6.png";